import { gql } from '@apollo/client';
import { FR_FLEET_FIELDS } from './fragments/machine';

export const UPDATE_MACHINE_OPERATIONHOUR = gql`
    mutation updateMachineOperationHour($MachineMetricId: Int!, $OperationHourValue: Float!) {
        updateMachineOperationHour(
            data: { MachineMetricId: $MachineMetricId, OperationHourValue: $OperationHourValue }
        ) {
            MachineMetricId
            MetricType
            Latest
            Min
            Max
            Date
            MachineMetricType {
                MachineMetricTypeId
                Name
                Created
                Updated
            }
            Utc
        }
    }
`;

export const SET_MACHINE_OPERATIONHOUR = gql`
    mutation setMachineOperationHour(
        $MachineId: Int!
        $OperationHourValue: Float!
        $HourDate: Date!
    ) {
        setMachineOperationHour(
            data: {
                MachineId: $MachineId
                OperationHourValue: $OperationHourValue
                HourDate: $HourDate
            }
        ) {
            ...fr_FleetFields
        }
    }
    ${FR_FLEET_FIELDS}
`;
